import { Grid, Title, Stack } from '@mantine/core';

import Lov from '../../../utils/Lov';
import Viewer from '../../../components/SmartForm/Viewer';
import ViewInfo from '../../../components/SmartForm/Viewer/ViewInfo';
import type { FieldItemGroup } from '../../../store/types';

interface Avaliacao {
  id: number;
  tipo: string;
  fieldItemGroups: FieldItemGroup[];
}

interface TabAvaliacoesProps {
  unidadeId: number;
  unidadeFieldItemGroups?: FieldItemGroup[];
  avaliacoes?: Avaliacao[];
}

export default function TabAvaliacoes({
  unidadeId,
  unidadeFieldItemGroups,
  avaliacoes,
}: TabAvaliacoesProps) {
  const renderTabUnidade = () => {
    if (!unidadeFieldItemGroups || unidadeFieldItemGroups.length === 0) return null;

    const firstFieldItemGroup = unidadeFieldItemGroups[0];
    const fieldItemGroups = unidadeFieldItemGroups.filter((x) => x !== firstFieldItemGroup);

    return (
      <Grid.Col span={{ base: 12, md: 6 }} key="Unidade">
        <Title order={4} mb="xs">INFORMAÇÕES DA UNIDADE</Title>
        <ViewInfo fieldItemGroups={[firstFieldItemGroup]} />
        <Viewer type="tables" fieldItemGroups={fieldItemGroups} />
      </Grid.Col>
    );
  };

  const renderTabAvaliacao = (item: Avaliacao) => {
    if (!item.tipo || !item.fieldItemGroups?.length) return null;

    const firstFieldItemGroup = item.fieldItemGroups[0];
    const fieldItemGroups = item.fieldItemGroups.filter((x) => x !== firstFieldItemGroup);

    return (
      <Grid.Col span={{ base: 12, md: 6 }} key={item.id}>
        <Title order={4} mb="xs">AVALIAÇÃO DE {Lov.avaliacaoTipo.get(item.tipo)}</Title>
        <ViewInfo fieldItemGroups={[firstFieldItemGroup]} />
        <Viewer type="tables" fieldItemGroups={fieldItemGroups} />
      </Grid.Col>
    );
  };

  if (!avaliacoes) {
    return <Stack>{unidadeId}</Stack>;
  }

  return (
    <Grid gap="md">
      {renderTabUnidade()}
      {avaliacoes.map(renderTabAvaliacao)}
    </Grid>
  );
}
